import '../sass/text-and-media-block.scss';
import './text-and-media-block';
